import { render, staticRenderFns } from "./topFiveEquipmentFailures.vue?vue&type=template&id=8581dd24&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./topFiveEquipmentFailures.vue?vue&type=style&index=0&id=8581dd24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8581dd24",
  null
  
)

export default component.exports